<template>
    <section class="footer blackBack">
        <div class="join detectMobVisibility">
            <h2 class="page__h1 join__title">{{ $t('header.join') }}</h2>
            <Join/>
        </div>
        <div class="footer__wrapper hideTop detectMobVisibility">
            <div class="navigation">
                <div class="navigation__column homePage_logo">
                    <div class="navigation__item navigation__item_page emule" data-menuanchor="home">
                        <a href="/" class="navigation__link navigation__link_page">{{ $t('header.home') }}</a>
                    </div>
                    <div class="navigation__item emule" data-menuanchor="approach">
                        <a href="about" class="navigation__link">{{ $t('header.approach') }}</a>
                    </div>
                    <div class="navigation__item emule" data-menuanchor="scale">
                        <a href="brand_mission_strategy" class="navigation__link">{{ $t('header.scale') }}</a>
                    </div>
                    <div class="navigation__item emule" data-menuanchor="marketing_support">
                        <a href="#brands" class="navigation__link">{{ $t('header.marketingSupport') }}</a>
                    </div>
                    <div class="navigation__item emule" data-menuanchor="brands">
                        <a href="#brands/all_brands" class="navigation__link">{{ $t('header.brands') }}</a>
                    </div>
                    <div class="navigation__item emule" data-menuanchor="customer_service">
                        <a href="#customer_service" class="navigation__link">{{ $t('header.customerService') }}</a>
                    </div>
                    <div class="navigation__item emule" data-menuanchor="software_integration">
                        <a href="https://b2b.smartgroup.ua" class="navigation__link">{{ $t('header.softwareIntegration') }}</a>
                    </div>
                </div>
                <div class="navigation__column outer_pages">
                    <div class="navigation__item navigation__item_page" data-menuanchor="home#home">
                        <router-link :to="{name: ((this.$i18n.locale == this.mainLang)? '' : this.$i18n.locale+'.') + 'home', params: { locale: ((this.$i18n.locale == this.mainLang)? '' : '/' + this.$i18n.locale) }}" class="navigation__link navigation__link_page">{{ $t('header.home') }}</router-link>
                    </div>
                    <div class="navigation__item" data-menuanchor="approach">
                        <router-link :to="{name: ((this.$i18n.locale == this.mainLang)? '' : this.$i18n.locale+'.') + 'about', params: { locale: ((this.$i18n.locale == this.mainLang)? '' : '/' + this.$i18n.locale) }}" class="navigation__link">{{ $t('header.approach') }}</router-link>
                    </div>
                    <div class="navigation__item" data-menuanchor="scale">
                        <router-link :to="{name: ((this.$i18n.locale == this.mainLang)? '' : this.$i18n.locale+'.') + 'brand_mission_strategy', params: { locale: ((this.$i18n.locale == this.mainLang)? '' : '/' + this.$i18n.locale) }}" class="navigation__link">{{ $t('header.scale') }}</router-link>
                    </div>
                    <div class="navigation__item" data-menuanchor="brands">
                        <router-link :to="{name: ((this.$i18n.locale == this.mainLang)? '' : this.$i18n.locale+'.') + 'home#brands', params: { locale: ((this.$i18n.locale == this.mainLang)? '' : '/' + this.$i18n.locale) }}" class="navigation__link">{{ $t('header.marketingSupport') }}</router-link>
                    </div>
                    <div class="navigation__item" data-menuanchor="marketing_support">
                        <a href="/#brands/all_brands" class="navigation__link">{{ $t('header.brands') }}</a>
                    </div>
                    <div class="navigation__item" data-menuanchor="customer_service">
                        <router-link :to="{name: ((this.$i18n.locale == this.mainLang)? '' : this.$i18n.locale+'.') + 'home#customer_service', params: { locale: ((this.$i18n.locale == this.mainLang)? '' : '/' + this.$i18n.locale) }}" class="navigation__link">{{ $t('header.customerService') }}</router-link>
                    </div>
                    <div class="navigation__item" data-menuanchor="software_integration">
                        <a href="https://b2b.smartgroup.ua" class="navigation__link">{{ $t('header.softwareIntegration') }}</a>
                    </div>
                </div>
                <!-- <div class="navigation__column">
                    <div class="navigation__item navigation__item_page">
                        <router-link :to="{name: ((this.$i18n.locale == this.mainLang)? '' : this.$i18n.locale+'.') + 'about', params: { locale: ((this.$i18n.locale == this.mainLang)? '' : '/' + this.$i18n.locale) }}" class="navigation__link navigation__link_page">{{ $t('header.about') }}</router-link>
                    </div>
                </div> -->
                <div class="navigation__column">
                    <div class="navigation__item navigation__item_page">
                        <a href="https://b2b.smartgroup.ua" class="navigation__link navigation__link_page">{{ $t('header.partners') }}</a>
                    </div>
                    <div class="navigation__item navigation__item_page">
                        <a href="#scale" class="navigation__link navigation__link_page">{{ $t('header.retail') }}</a>
                    </div>
                    <div class="navigation__item navigation__item_page">
                        <a href="https://service.smartgroup.ua" class="navigation__link navigation__link_page">{{ $t('header.service') }}</a>
                    </div>
                    <div class="navigation__item navigation__item_page">
                        <router-link :to="{name: this.curLocaleName + 'contact', params: { locale: this.curLocaleAlias }}" class="navigation__link navigation__link_page">{{ $t('header.contacts') }}</router-link>
                    </div>
                </div>
                
                <div class="navigation__column">
                    <div class="social">
                        <a v-for="(item, index) in socials" :key="index" :href="item.link" class="social__link" target="_blank" rel="nofollow">{{ item.title }}</a>

                        <!-- <a href="https://once.agency/" target="_blank" class="design">Designed at <span class="design__text">once.</span></a> -->
                    </div>
                </div>
            </div>
            
            <div class="copyright">
                <span class="copyright__text">2012 - <span class="icon-infiniti copyright__icon"></span></span>
                <span class="copyright__text">Smart Group, Inc.</span>
            </div>
        </div>
    </section>
</template>

<script>
    import $ from "jquery";
    import i18n from '../lang/lang'
    import Join from '@/components/join_block.vue'
    import params from '../../public/site_config.json'
    
    export default {
        components: {
            Join
        },
        data: function () {
            return {
                mainLang: params.initial_lang,
                socials: params.socials
            }
        },
        methods: {
            
        },
        mounted() {
            
        }
    }
    
    $(document).on('click', '.emule', function() {
        var target = $(this).attr('data-menuanchor');
        
        if(target) {
            $.fn.fullpage.moveTo(target, false);
        }
    });
</script>

<style scoped lang="stylus">
    .footer
        background #222
        padding-bottom 30px
        font-size 14px
        position relative

        @media (min-width 1024px)
            padding 0
            
        @media (min-width 1600px)
            font-size 16px

    .footer__wrapper
        @media (min-width 1024px)
            display flex
            justify-content flex-start
            padding 80px
            min-height 240px

    .join
        padding 64px 20px 64px
        background url(../assets/images/svg/pattern.svg) center 0 no-repeat
        background-size cover

        @media (min-width 700px)
            padding 64px 35px 64px
        
        @media (min-width 1024px)
            padding 80px 80px 80px 250px

    .join__title
        font-size 36px
        color #fff
        font-weight bold

        @media (min-width 1024px)
            font-size 48px

    .navigation
        padding 48px 20px 25px
        margin-bottom 70px
        box-sizing border-box
        border-bottom 1px solid rgba(#808080, .2)

        @media (min-width 700px)
            padding 48px 35px 25px
        
        @media (min-width 1024px)
            display flex
            padding 0
            margin 0
            margin-left 133px
            border none
            flex-grow 3
            position absolute
            left 250px
            width calc(100% - 250px)
            
        @media (min-width 1600px)
            width calc(100% - 250px)

    .navigation__column

        @media (min-width 1024px)
            width 33.33%

    .navigation__item
        padding 12px 0
        
        @media (min-width 1024px)
            padding 0 0 12px 0

    .navigation__item_page
        padding 32px 0 4px

        @media (min-width 1024px)
            padding 0 0 12px 0

    .navigation__link
        line-height 1.7
        color #fff
        cursor pointer

    .navigation__link_page
        font-weight bold

    .social
        position absolute
        width calc(100% - 40px)
        left 0
        margin-top 25px
        display flex
        padding 24px 20px
        justify-content space-between
        border-bottom 1px solid rgba(#808080, .2)

        @media (min-width 700px)
            padding 24px 35px
            width calc(100% - 70px)
        
        @media (min-width 1024px)
            position relative
            width auto
            left 0
            margin-top 0
            border none
            flex-direction column
            padding 0
            justify-content flex-start
            flex-grow 1

    .social__link
        line-height 1.7
        color #fff

        @media (min-width 1024px)
            margin-bottom 12px

    .copyright
        color rgba(#808080, .5)
        padding 24px 20px
        display flex
        align-items center
        line-height 1.7

        @media (min-width 700px)
            padding 24px 35px
        
        @media (min-width 1024px)
            flex-direction column-reverse
            align-items flex-start
            justify-content flex-end
            padding 0
            order -1
            flex-grow 1

    .copyright__text

        @media (min-width 1024px)
            margin-bottom 5px

    .copyright__icon
        margin 0 10px 0 0
        font-size 20px
        position relative
        top 5px

    .design
        position absolute
        top calc(100% + 60px)
        left 20px
        white-space nowrap
        color rgba(#808080, .5)
            
        @media (min-width 700px)
            left 35px
        
        @media (min-width 1024px)
            left 0
            top calc(100% + 140px)

    .design__text
        font-weight bold
        -webkit-transition all .5s cubic-bezier(.25,.01,.25,1)
        -moz-transition all .5s cubic-bezier(.25,.01,.25,1)
        transition all .5s cubic-bezier(.25,.01,.25,1)
        
    .design:hover .design__text
        color #fff
</style>
